import { render, staticRenderFns } from "./WireTransferInfo.vue?vue&type=template&id=195c423f&scoped=true"
import script from "./WireTransferInfo.vue?vue&type=script&lang=js"
export * from "./WireTransferInfo.vue?vue&type=script&lang=js"
import style0 from "./WireTransferInfo.vue?vue&type=style&index=0&id=195c423f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195c423f",
  null
  
)

export default component.exports